import React from 'react';
import PropTypes from 'prop-types';

const ConsultationList = ({ consultations, currentUserId, onEdit }) => {
  if (consultations.length === 0) {
    return <p>No past consultation notes found.</p>;
  }

  return (
    <div className="consultation-list space-y-2">
      {consultations.map((consultation) => (
        <div key={consultation.id} className="item border border-gray-300 p-3 rounded bg-gray-50">
          <div
            className="prose"
            dangerouslySetInnerHTML={{
              __html: consultation.notes || '<em>No notes provided.</em>',
            }}
          />
          <p className="text-sm text-gray-500 mt-2">
            {(() => {
              const date = new Date(consultation.created_at);
              const day = date.getDate();
              const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
              const month = date.toLocaleDateString('en-US', { month: 'long' });
              const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

              return `Created: ${day} ${weekday} ${month} ${time}`;
            })()}
          </p>
          {consultation.user_id === currentUserId && (
            <button
              type="button"
              onClick={() => onEdit(consultation)}
              className="primary"
            >
              Edit
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

ConsultationList.propTypes = {
  consultations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      notes: PropTypes.string,
      created_at: PropTypes.string.isRequired,
      user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
  currentUserId: PropTypes.number.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default ConsultationList;
